<template>
 <div class="content work_wrapper search_content analysis">
        <v-row class="search_box">
            <v-col>
              <searchBar></searchBar>
            </v-col>
        </v-row>
        <v-row class="conter_outer">
            <v-col>
                <div class="right_side_outer set">
                    <div class="flex_style left topName bread_route">
                        <div class="flex_style left">
                            <span class="active">数据分析</span>
                            <v-icon>mdi-chevron-right</v-icon>
                            <span>图表设置</span>
                        </div>
                    </div>
                    <div class="right_side">
                        <v-row class="nav_top_btns">
                            <v-col xs="12">
                                <div class="btns_list">
                                    <div class="flex_style left">
                                    </div>
                                    <div class="flex_style right" title="导出">
                                        <div class="btn_item hand" title="保存的项目" @click="goProList">
                                            <v-icon>mdi-file-cabinet</v-icon>
                                        </div>
                                        <div class="btn_item hand" title="设置" @click="openSetting">
                                            <v-icon>mdi-cog</v-icon>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <div id="drop" v-if="chatNameList1&&chatNameList1.length>0">
                            <!-- <div>拖拽页面展示</div> -->
                            <div class="content">
                                <div class="grid">
                                    <div class="item" v-for="(item,index) in chatNameList1" :key="index">
                                        <div class="item-content">
                                            <div class="chart-block">
                                                <h3>
                                                    {{ item.label }}
                                                </h3>
                                                <!-- <div class="" style="height: 200px"></div> -->
                                                <div :id="'chartbox'+index" class="chart-box" style="height: 200px"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="item" v-if="chatNameList1[1]">
                                        <div class="item-content">
                                            <div class="chart-block">
                                                <h3>
                                                    {{ chatNameList1[1].label }}
                                                </h3>
                                                <div class="" style="height: 200px"></div>
                                           
                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div class="item">
                                        <div class="item-content"><ApplyLine :data="data" v-if="data"></ApplyLine></div>
                                    </div>
                                    <div class="item">
                                        <div class="item-content"><IPCSort :data="treeData" v-if="treeData"></IPCSort></div>
                                    </div>
                                    <div class="item">
                                        <div class="item-content"><Applyer :data="applyData" v-if="applyData"></Applyer></div>
                                    </div>
                                    <div class="item">
                                        <div class="item-content"><Slsort :data="slData" v-if="slData"></Slsort></div>
                                    </div>
                                    <div class="item">
                                        <div class="item-content"><CPCSort :data="treeData1" v-if="treeData1"></CPCSort></div>
                                    </div>
                                    <div class="item">
                                        <div class="item-content"><FtermSort :data="treeData2" v-if="treeData2"></FtermSort></div>
                                    </div> -->
                                </div>
                                <v-row v-if="false" class="grid mb-12">
                                    <v-col class="item" sm="12" md="6" lg="6">
                                        <div class="item-content">
                                        <MonthlyStats></MonthlyStats>
                                        </div>
                                    </v-col>
                                    <v-col class="item" sm="12" md="6" lg="6">
                                        <div class="item-content">
                                        <ApplyTrend2></ApplyTrend2>
                                        </div>
                                    </v-col>
                                    <v-col class="item" sm="12" md="6" lg="6">  
                                        <div class="item-content">   
                                        <ApplyTrend></ApplyTrend>
                                        </div>
                                    </v-col>
                                    <v-col class="item" sm="12" md="6"  lg="6">
                                        <div class="item-content">
                                        <ProvinceChart></ProvinceChart>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="600">
            <v-card>
                <v-card-title class="headline  lighten-2">设置</v-card-title>

                <v-card-text>
                    <v-tabs>
                        <v-tab key="1">分析概览</v-tab>
                        <v-tab key="2">搜索全局设置</v-tab>
                        <v-tab-item key="1">
                            <div class="common_tabs_wrapper">
                                <div class="flex_style left shuttle_wrapper">
                                    <div class="item">
                                        <div>可选图表</div>
                                        <div class="item_center">
                                            <ul>
                                                <li class="hand" v-for="(item1,index1) in nameList" @click="move(item1)" :key="index1">
                                                    <span>{{item1.label}}</span>
                                                    <span class="icon"><v-icon>mdi-plus</v-icon></span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div>显示图表 ({{chatNameList1.length}}/6)</div>
                                        <div class="item_center">
                                            <ul>
                                                <li class="hand" v-for="(item1,index1) in chatNameList1" @click="move1(item1)" :key="index1">
                                                    <span>{{item1.label}}</span>
                                                    <span class="icon"><v-icon>mdi-window-close</v-icon></span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item key="2">
                            <div style="padding: 24px;">
                                <v-radio-group v-model="radioGroup">
                                    <v-radio
                                        v-for="(item, index) in radioList"
                                        :key="index"
                                        :label="`${item.name}`"
                                        :value="item.key"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="dialog = false">取消</v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="handleSetOk">确定</v-btn>
                </v-card-actions> 
            </v-card>
        </v-dialog>
 </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/web-animations/2.3.2/web-animations.min.js"></script>
<!-- <script src="https://cdn.jsdelivr.net/gh/haltu/muuri@0.9.3/dist/muuri.min.js"></script>-->
<script>
import echarts from "echarts";
// import ApplyTrend from "@/components/widgets/applyTrend.vue";
// import ApplyTrend2 from "@/components/widgets/applyTrend2.vue";
import searchBar from "@/components/side/searchBar.vue";
// import ProvinceChart from "@/components/widgets/ProvinceChart.vue";
// import MonthlyStats from "@/components/widgets/monthlyStats.vue";
// import ApplyLine from '@/components/chartDom/line.vue'
// import Slsort from '@/components/chartDom/lineBar.vue'
// import Applyer from '@/components/chartDom/insideBar.vue'
// import IPCSort from '@/components/chartDom/treeMap.vue'
// import CPCSort from '@/components/chartDom/treeMap.vue'
// import FtermSort from '@/components/chartDom/treeMap.vue'
import Muuri from 'muuri'
import {mapState} from 'vuex'
export default {
    data() {
        return {
            dialog: false,
            chatNameList1: [
                {
                    columnKey: 'trend',
                    key: 'applicationYear',
                    label: '申请趋势',
                    default: 'lineChart'
                },
                {
                    columnKey: 'trend',
                    key: 'publicationYear',
                    label: '公开趋势',
                    default: 'lineChart'
                },
                {
                   columnKey: 'technology',
                   key: 'ipc3',
                   label: '技术构成',
                   default: 'barChart'
                },
                {
                   columnKey: 'technology',
                   key: 'ipc3-applicationYear',
                   label: '技术申请趋势',
                   default: 'lineChart'
                },
                {
                    columnKey: 'technology',
                    key: 'ipc3-publicationYear',
                    label: '技术公开趋势',
                    default: 'lineChart'
                },
                {
                    columnKey: 'trend',
                    key: 'ipc3-countryCode',
                    label: '技术全球分布',
                    default: 'barChart'
                }
            ] ,
            chatNameList: [],
            chatNameList2: [
                {
                    key: 'fterm',
                    name: 'F-Term完成码排名'
                },
                 {
                    key: 'applyer',
                    name: '[标]当前申请（专利权）人排名'
                },
                 {
                    key: 'applyer1',
                    name: '[标]原始申请（专利权）人排名'
                },
                 {
                    key: 'applyer2',
                    name: '原始申请（专利权）人排名'
                },
                 {
                    key: 'docdb',
                    name: 'Docdb申请（专利权）人排名'
                },
                 {
                    key: 'inventor',
                    name: '发明人排名'
                },
                 {
                    key: 'agency',
                    name: '代理机构排名'
                },
                 {
                    key: 'agent',
                    name: '代理人排名'
                },
                 {
                    key: 'open_trend',
                    name: '公开趋势'
                },
                 {
                    key: 'apply_trend',
                    name: '申请趋势'
                },
                 {
                    key: 'ipc',
                    name: 'IPC分类排名'
                },
                {
                    key: 'curapply',
                    name: '当前申请（专利权）人排名'
                },
                {
                    key: 'cpc',
                    name: 'CPC分类排名'
                }
            ],
            radioGroup: '',
            radioList: [
                {
                    key: 'all',
                    name: '所有搜索结果（不分组）'
                },
                 {
                    key: 'every1',
                    name: '每件申请显示一个公开文本'
                },
                 {
                    key: 'every2',
                    name: '每组简单同族一个专利代表'
                },
                 {
                    key: 'every3',
                    name: '每组IPNPADOC同族一个专利代表'
                }
            ],
            data: {
                'time': ['2012', '2013', '2014', '2015', '2016', '2017', '2018'],
                'num': [120, 200, 150, 80, 70, 110, 130],
                'name': ''
            },
            slData: {
                'time': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                'num': [120, 200, 150, 80, 70, 110, 130],
                'name': '受理局排名'
            },
            applyData: {
                'time': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                'num': [120, 200, 150, 80, 70, 110, 130],
                'name': '当前申请(专利权)人排名'
            },
            treeData: {
                list: [
                    {
                        name: "C08K3",
                        path: "Accessibility",
                        value: 40
                    },
                    {
                        name: "B012K",
                        path: "Accounts",
                        value: 180,
                    },
                    {
                        name: "H012K",
                        path: "Accounts",
                        value: 380,
                    },
                    {
                        name: "D012K",
                        path: "Accounts",
                        value: 80,
                    }
                ],
                name: 'IPC分类排名'
            },
            treeData1: {
                list: [
                    {
                        name: "C08K3",
                        path: "Accessibility",
                        value: 40
                    },
                    {
                        name: "B012K",
                        path: "Accounts",
                        value: 180,
                    },
                    {
                        name: "H012K",
                        path: "Accounts",
                        value: 380,
                    },
                    {
                        name: "D012K",
                        path: "Accounts",
                        value: 80,
                    }
                ],
                name: 'CPC分类排名'
            },
            treeData2: {
                list: [
                    {
                        name: "C08K3",
                        path: "Accessibility",
                        value: 40
                    },
                    {
                        name: "B012K",
                        path: "Accounts",
                        value: 180,
                    },
                    {
                        name: "H012K",
                        path: "Accounts",
                        value: 380,
                    },
                    {
                        name: "D012K",
                        path: "Accounts",
                        value: 80,
                    }
                ],
                name: 'F-Term完整码排名'
            },
            barOption: {}
        }
    },
    mounted() {
        if(localStorage.getItem('setting')) {
            this.chatNameList1 = JSON.parse(localStorage.getItem('setting'))
        }
        let list = this.nameList
        list.forEach((item,index)=>{
            this.chatNameList1.forEach((item1)=>{
                if(item.key == item1.key) {
                    this.nameList.splice(index,1)
                }
            })
        })
        console.log('chatNameList1', this.chatNameList1)
        setTimeout(() => {
            var grid = new  Muuri('.grid', {
                dragEnabled: true,
                layout: {
                    fillGaps: true
                }
                // dragContainer: document.getElementById('drop'),
            });
            window.addEventListener('load', function () {
                grid.refreshItems().layout();
                document.body.classList.add('images-loaded');
            });
        }, 1000);
        setTimeout(() => {
            this.getChart()
        }, 3000);
    },
    components: {
        searchBar,
        // ApplyTrend,
        // ApplyTrend2,
        // ProvinceChart,
        // MonthlyStats,
        // ApplyLine,
        // Slsort,
        // Applyer,
        // IPCSort,
        // CPCSort,
        // FtermSort
    },
    computed: {
        ...mapState('analy',{
            nameList: (state) => {
                let list = state.defauleSearchSchema.defaultFilter
                let newArr = []
                list.forEach((item)=>{
                    let buckets = item.buckets
                    buckets = buckets.map((item1)=>{
                         item1.columnKey = item.key
                         return item1
                    })
                    newArr = newArr.concat(buckets)
                })
                return newArr
            }
        }),
    },
    methods: {
        openSetting() {
            this.dialog = true
        },
        move(val) {
            if(this.chatNameList1.length==6) {
                return false
            }
            let list  = JSON.parse(JSON.stringify(this.nameList))
            list.forEach((item, index)=>{
                if(item.key == val.key) {
                    this.nameList.splice(index, 1);
                    this.chatNameList1.push(item)
                }
            })
        },
        move1(val) {
            let list  = JSON.parse(JSON.stringify(this.chatNameList1))
            list.forEach((item, index)=>{
                if(item.key == val.key) {
                    this.chatNameList1.splice(index, 1);
                    this.nameList.push(item)
                }
            })
        },
        handleSetOk() {
            console.log('chatNameList1', this.chatNameList1)
            console.log(this.radioGroup)
            localStorage.setItem('setting',JSON.stringify(this.chatNameList1))
            this.dialog = false
            setTimeout(() => {
                var grid = new  Muuri('.grid', {
                    dragEnabled: true,
                    layout: {
                        fillGaps: true
                    }
                    // dragContainer: document.getElementById('drop'),
                });
                window.addEventListener('load', function () {
                    grid.refreshItems().layout();
                    document.body.classList.add('images-loaded');
                });
            }, 1000);
            setTimeout(()=>{
                this.getChart()
            },2000)
        },
        goProList() {
            this.$router.push({
                path: '/analyse'
            })
        },
        getChart() {
            let option = {
                tooltip: {
                    show: true,
                    formatter: '名称： {b}<br /> 数值： {c}'
                },
                xAxis: {
                    show: true,
                    type: 'category',
                    data: this.data.time
                },
                yAxis: {
                    show: true,
                    type: 'value'
                },
                series: [{
                    data: this.data.num,
                    type: 'line',
                    itemStyle: {
                        color: ['#1080FF']
                    }
                }]
            }
            let option1 = {
                    tooltip: {
                        show: true,
                        formatter: '名称： {b}<br /> 数值： {c}'
                    },
                    xAxis: {
                        show: true,
                        type: 'category',
                        data: this.data.time
                    },
                    yAxis: {
                        show: true,
                        type: 'value'
                    },
                    series: [{
                        data: this.data.num,
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        },
                        itemStyle: {
                            color: ['#1080FF']
                        }
                    }]
            }
            let myOption = option
            this.chatNameList1.forEach((item,index)=>{
                let dom = document.getElementById('chartbox'+index)
                // console.log('dom', dom)
                if(item.default == 'lineChart') {
                    myOption = option
                }
                if(item.default == 'barChart') {
                    myOption = option1
                }
                let myChart = echarts.init(dom)
                myChart.setOption(myOption);
                // window.addEventListener("resize", () => {
                //     myChart.resize();
                // });
            })
        }
    }
}
</script>
<style scoped>
.grid {
  position: relative;
}
.item {
  display: block;
  position: absolute;
  /* width: 50%; */
  width: 420px;
  max-width: 100%;
  height: 300px;
  z-index: 1;
    border-radius: 1px solid #ccc;
    border-radius: 4px;
}
.item.muuri-item-dragging {
  z-index: 3;
}
.item.muuri-item-releasing {
  z-index: 2;
}
.item.muuri-item-hidden {
  z-index: 0;
}
.item-content {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>